import { ComponentType } from '@angular/cdk/portal';
import { KeyValue } from '@angular/common';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { DialogPosition, MatDialog } from '@angular/material/dialog';
import { MatSliderChange } from '@angular/material/slider';
import { TranslateService } from '@ngx-translate/core';
import * as aspObjects from '../asp/aspObjects';
import { MapMngr } from '../asp/MapMngr';
import { SensorCoreObject } from '../asp/SensorCoreObject';
import { constsMngr } from '../common/consts';
import * as enums from '../common/enums';
import * as settings from '../common/settings';
import * as utils from '../common/utils';
import { AcousticVectorSettingsComponent } from './acvec-settings/acvec-settings.component';
import { MapsSettingsComponent } from './maps-settings/maps-settings.component';
import { NaiNatSettingsComponent } from './nainat-settings/nainat-settings.component';
import { PlotsSettingsComponent } from './plots-settings/plots-settings.component';
import { SensorsSettingsComponent } from './sensor-settings/sensors-settings.component';
import { TracksSettingsComponent } from './tracks-settings/tracks-settings.component';

@Component({
  selector: 'display-filter',
  templateUrl: './display-filter.component.html',
  styleUrls: ['./display-filter.component.scss'],
})
export class DisplayFilterComponent {
  isShown: boolean = false;
  previousLang: string;

  userPerm: enums.Permission;

  private static filterTrackIdent: boolean = true;

  @ViewChild('displayFilter', { read: ElementRef }) displayFilter: ElementRef;

  @ViewChild('mapsSettingsBtn', { read: ElementRef }) mapsSettingsBtn: ElementRef;
  @ViewChild('zonesSettingsBtn', { read: ElementRef }) zonesSettingsBtn: ElementRef;
  @ViewChild('acvecsSettingsBtn', { read: ElementRef }) acvecsSettingsBtn: ElementRef;
  @ViewChild('sensorsSettingsBtn', { read: ElementRef }) sensorsSettingsBtn: ElementRef;
  @ViewChild('targetsSettingsBtn', { read: ElementRef }) targetsSettingsBtn: ElementRef;
  @ViewChild('plotsSettingsBtn', { read: ElementRef }) plotsSettingsBtn: ElementRef;
  @ViewChild('tracksSettingsBtn', { read: ElementRef }) tracksSettingsBtn: ElementRef;

  FilterType = settings.DisplayFilter;
  FilterTypeTitles = settings.DisplayFilterTitles;

  mapElements: string[] = [];

  mapElementsOn = settings.userSettings.mapElementsOn;

  filterExpanded: boolean[];
  filterOn = settings.userSettings.filterOn;

  TrackTransText: string = "";

  TrackIdentity = enums.Hostility;
  TrackIdentityTitles = enums.HostilityTitles;

  trackIdentitiesOn = settings.userSettings.trackHostilityOn;

  trackSources: Map<string, number> = new Map();
  plotSources: Map<string, number> = new Map();

  mapBrightness: number = settings.userSettings.bgMapOpacity * 100.0;
  pointsBrightness: number = settings.userSettings.pointOpacity * 100.0;
  tracksBrightness: number = settings.userSettings.trackOpacity * 100.0;
  plotsBrightness: number = settings.userSettings.plotOpacity * 100.0;
  nainatBrightness: number = settings.userSettings.nainatOpacity * 100.0;

  identityTrackElements: string[] = [];
  identityTrackElementsOn = settings.userSettings.identityTrackElementsOn;

  clsTrackElements: string[] = [];
  clsTrackElementsOn = settings.userSettings.clsTrackElementsOn;

  snsTypeElements: string[] = [];
  snsTypeElementsOn = settings.userSettings.snsTypeElementsOn;

  AcousticSources: string[] = [];
  AcousticSourcesOn = settings.userSettings.acousticSourcesOn;

  AcousticVectorTypesOn = (settings.userSettings.acousticVectorTypesOn);

  constructor(private dialog: MatDialog,
    private translateService: TranslateService) {
    this.translateService.get('DISPLAY_FILTER').subscribe((translated: string) => {
      this.FilterTypeTitles = translated['FILTER_TITLES'];
      this.TrackIdentityTitles = translated['HOSTILITY_TITLES'];
      this.TrackTransText = translated['DANGER_ZONE'];
    });
    this.previousLang = this.translateService.currentLang;

    this.userPerm = settings.userSettings.userPerm;

    let numFilters = Object.keys(this.FilterType).length / 2;

    this.filterExpanded = [];
    for (let i = 0; i < numFilters; i++)
      this.filterExpanded[i] = false;

    for (let i = 0; i < constsMngr.mapDisplayElementCount(); i++)
      this.mapElements.push(constsMngr.mapDisplayElementTitle(i));

    console.log(this.FilterTypeTitles[this.FilterType.AcousticVector]);
  }

  static setFilterTrackIdent(filter: boolean) {
    DisplayFilterComponent.filterTrackIdent = filter;
  }

  getFilterTrackIdent() {
    return DisplayFilterComponent.filterTrackIdent;
  }

  enumKeys(enm) {
    return Object.keys(enm).filter(key => !isNaN(Number(key)));
  }

  show() {
    this.isShown = true;
    if (this.translateService.currentLang != this.previousLang) {
      this.translateService.get('DISPLAY_FILTER').subscribe((translated: string) => {
        this.FilterTypeTitles = translated['FILTER_TITLES'];
        this.TrackIdentityTitles = translated['HOSTILITY_TITLES'];
      });
      this.previousLang = this.translateService.currentLang;
    }
  }

  hide() {
    let dlg = this.dialog.getDialogById(MapsSettingsComponent.DIALOG_ID);
    if (dlg)
      dlg.close();
    dlg = this.dialog.getDialogById(SensorsSettingsComponent.DIALOG_ID);
    if (dlg)
      dlg.close();
    dlg = this.dialog.getDialogById(PlotsSettingsComponent.DIALOG_ID);
    if (dlg)
      dlg.close();
    dlg = this.dialog.getDialogById(TracksSettingsComponent.DIALOG_ID);
    if (dlg)
      dlg.close();
    dlg = this.dialog.getDialogById(AcousticVectorSettingsComponent.DIALOG_ID);
    if (dlg)
      dlg.close();
    dlg = this.dialog.getDialogById(NaiNatSettingsComponent.DIALOG_ID);
    if (dlg)
      dlg.close();
    this.isShown = false;
  }

  minBrightness() {
    return 0;
  }

  maxBrightness() {
    return 100;
  }

  // Maps

  onMapsBtnClick() {
    this.filterExpanded[this.FilterType.Maps] = !this.filterExpanded[this.FilterType.Maps];
  }

  onMapsDisplayBtnClick() {
    settings.userSettings.toggleFilterOn(this.FilterType.Maps);
    MapMngr.redrawAllBackground();
  }

  onMapElemToggle(mapElem) {
    settings.userSettings.toggleMapElementOn(mapElem);
    MapMngr.redrawAllBackground();
  }

  onMapsSettingsBtnClick() {
    this.openSettingsDlg(MapsSettingsComponent, MapsSettingsComponent.DIALOG_ID, this.mapsSettingsBtn);
  }

  mapsSettingsDisabled() {
    return this.dialog.getDialogById(MapsSettingsComponent.DIALOG_ID) !== undefined;
  }

  onMapBrightnessSliderChanged(event: MatSliderChange) {
    settings.userSettings.setBgMapOpacity(event.value / 100.0);
    MapMngr.redrawAllBackground();
  }

  // Zones

  onZonesBtnClick() {
    this.filterExpanded[this.FilterType.NaiNat] = !this.filterExpanded[this.FilterType.NaiNat];
  }

  onZonesDisplayBtnClick() {
    settings.userSettings.toggleFilterOn(this.FilterType.NaiNat);
  }

  onZonesSettingsBtnClick() {
    this.openSettingsDlg(NaiNatSettingsComponent, NaiNatSettingsComponent.DIALOG_ID, this.zonesSettingsBtn);
  }

  zonesSettingsDisabled() {
    return this.dialog.getDialogById(NaiNatSettingsComponent.DIALOG_ID) !== undefined;
  }

  onNaiNatBrightnessSliderChanged(event: MatSliderChange) {
    settings.userSettings.setNaiNatOpacity(event.value / 100.0);
  }

  // Acoustic Vector
  onAcousticVectorBtnClick() {
    if (settings.userSettings.canSeeAi && settings.userSettings.canSeeSolo) {
      if (this.AcousticSources.length == 0) {
        let num = enums.SourceTitles.length;
        if (!settings.userSettings.canSeeAi)
          num--;
        for (let i = 1; i < num; i++)
          this.AcousticSources.push(enums.SourceTitles[i]);
      }
      this.filterExpanded[this.FilterType.AcousticVector] = !this.filterExpanded[this.FilterType.AcousticVector];
    }
  }

  onAcousticVectorDisplayBtnClick() {
    settings.userSettings.toggleFilterOn(this.FilterType.AcousticVector);
  }

  onAcousticVectorSettingsBtnClick() {
    this.openSettingsDlg(AcousticVectorSettingsComponent, AcousticVectorSettingsComponent.DIALOG_ID, this.acvecsSettingsBtn);
  }

  acousticVectorSettingsDisabled() {
    return this.dialog.getDialogById(AcousticVectorSettingsComponent.DIALOG_ID) !== undefined;
  }

  onAcousticVectorBrightnessSliderChanged(event: MatSliderChange) {
    settings.userSettings.setAcousticOpacity(event.value / 100.0);
  }

  // Sensors
  onSensorsBtnClick() {
    if (this.snsTypeElements.length == 0) {
      for (let i = 0; i < constsMngr.snsTypeDisplayElementCount(); i++)
        this.snsTypeElements.push(constsMngr.snsTypeDisplayElementTitle(i));
    }

    this.filterExpanded[this.FilterType.Sensors] = !this.filterExpanded[this.FilterType.Sensors];
  }

  onSensorsDisplayBtnClick() {
    settings.userSettings.toggleFilterOn(this.FilterType.Sensors);
  }

  onSensorsSettingsBtnClick() {
    this.openSettingsDlg(SensorsSettingsComponent, SensorsSettingsComponent.DIALOG_ID, this.sensorsSettingsBtn);
  }

  sensorsSettingsDisabled() {
    return this.dialog.getDialogById(SensorsSettingsComponent.DIALOG_ID) !== undefined;
  }

  onSensorsBrightnessSliderChanged(event: MatSliderChange) {
    settings.userSettings.setSensorsOpacity(event.value / 100.0);
  }

  onSnsTypeElemBtnClick(snsType) {
    settings.userSettings.toggleSnsTypeElementOn(snsType);
  }

  onAcousticSourceBtnClick(source) {
    settings.userSettings.toggleAcousticSourceOn(source);
  }

  onAcousticVectorTypeBtnClick(key: string) {
    settings.userSettings.toggleAcousticVectorTypeOn(key);
  }

  trackByKey(index: number, item: KeyValue<string, boolean>){
    return item.key;
  }

  // Targets

  onTargetsBtnClick() {
    this.filterExpanded[this.FilterType.Targets] = !this.filterExpanded[this.FilterType.Targets];
  }

  onTargetsDisplayBtnClick() {
    settings.userSettings.toggleFilterOn(this.FilterType.Targets);
  }

  onTargetsSettingsBtnClick() {
    // tbd
  }

  targetsSettingsDisabled() {
    // tbd
    return true;
  }

  // Tracks

  trackIcon(): string {
    return this.userPerm == 0 ? "tracks-filter" : "zones-filter";
  }

  trackText(): string {
    // return this.userPerm == 0 ? this.FilterTypeTitles[this.FilterType.Tracks] : this.TrackTransText;

    if (this.userPerm == 0) {
      return this.FilterTypeTitles[this.FilterType.Tracks];
    }
    else {
      return this.TrackTransText;
    }
  }

  onTracksBtnClick() {
    // we fill the array here because translation takes too much time to load....
    if (this.identityTrackElements.length == 0) {
      for (let i = 0; i < constsMngr.identityTrackDisplayElementCount(); i++)
        this.identityTrackElements.push(constsMngr.identityTrackDisplayElementTitle(i));
    }

    if (this.clsTrackElements.length == 0) {
      for (let i = 0; i < constsMngr.clsTrackDisplayElementCount(); i++)
        this.clsTrackElements.push(constsMngr.clsTrackDisplayElementTitle(i));
    }

    this.filterExpanded[this.FilterType.Tracks] = !this.filterExpanded[this.FilterType.Tracks];
  }

  onTracksDisplayBtnClick() {
    settings.userSettings.toggleFilterOn(this.FilterType.Tracks);
  }

  onTracksSettingsBtnClick() {
    this.openSettingsDlg(TracksSettingsComponent, TracksSettingsComponent.DIALOG_ID, this.tracksSettingsBtn);
  }

  tracksSettingsDisabled() {
    return this.dialog.getDialogById(TracksSettingsComponent.DIALOG_ID) !== undefined;
  }

  private generateSources(onlyRadar: boolean): Map<string, number> {
    let sources = new Map();

    let sensorIDs = aspObjects.sensorsPool.getAllSensorIDs();
    for (let sensorID of sensorIDs) {
      let sensor: SensorCoreObject = aspObjects.sensorsPool.getSensorBySensorID(sensorID);
      if (!onlyRadar || sensor.isRadar) {
        let sensorTitle = `${sensor.sic} | ${sensor.sac} | ${sensor.sensorLetter}`;
        sources.set(sensorTitle, sensorID);
      }
    }

    return sources;
  }

  getTracksSources() {
    let sensorNames = [];
    if (this.displayFilter.nativeElement.offsetParent === null) // display filter is not rendered
      return sensorNames;
    if (!this.filterExpanded[this.FilterType.Tracks]) // track filter is not expanded
      return sensorNames;

    this.trackSources = this.generateSources(false);

    sensorNames = Array.from(this.trackSources.keys());
    sensorNames.sort((a, b) => (a > b ? 1 : -1));
    return sensorNames;
  }

  trackSourceOn(sensorName) {
    let sensorID = this.trackSources.get(sensorName);
    return !settings.userSettings.trackSourcesHidden.has(sensorID);
  }

  onTrackSourceToggle(sensorName) {
    let sensorID = this.trackSources.get(sensorName);
    let hidden = settings.userSettings.trackSourcesHidden.has(sensorID);
    hidden ? settings.userSettings.showTrackSource(sensorID) : settings.userSettings.hideTrackSource(sensorID);
  }

  onTrackIdentityToggle(trackIdent) {
    settings.userSettings.toggleTrackHostilityOn(trackIdent);
  }

  trackToggleOnAllHostility() {
    settings.userSettings.toggleAllTrackHostility(true);
  }

  trackToggleOffAllHostility() {
    settings.userSettings.toggleAllTrackHostility(false);
  }



  onIdentityTrackElemBtnClick(trackElem) {
    settings.userSettings.toggleIdentityTrackElementOn(trackElem);
  }

  onTracksBrightnessSliderChanged(event: MatSliderChange) {
    settings.userSettings.setTrackOpacity(event.value / 100.0);
  }

  onClsTrackElemBtnClick(trackElem) {
    settings.userSettings.toggleClsTrackElementOn(trackElem);
  }


  // Plots

  onPlotsBtnClick() {
    this.filterExpanded[this.FilterType.Plots] = !this.filterExpanded[this.FilterType.Plots];
  }

  onPlotsDisplayBtnClick() {
    settings.userSettings.toggleFilterOn(this.FilterType.Plots);
  }

  onPlotsSettingsBtnClick() {
    this.openSettingsDlg(PlotsSettingsComponent, PlotsSettingsComponent.DIALOG_ID, this.plotsSettingsBtn);
  }

  plotsSettingsDisabled() {
    return this.dialog.getDialogById(PlotsSettingsComponent.DIALOG_ID) !== undefined;
  }

  getPlotsSources() {
    let sensorNames = [];
    if (this.displayFilter.nativeElement.offsetParent === null) // display filter is not rendered
      return sensorNames;
    if (!this.filterExpanded[this.FilterType.Plots]) // plot filter is not expanded
      return sensorNames;

    this.plotSources = this.generateSources(false);

    sensorNames = Array.from(this.plotSources.keys());
    sensorNames.sort((a, b) => (a > b ? 1 : -1));
    return sensorNames;
  }

  plotSourceOn(sensorName) {
    let sensorID = this.plotSources.get(sensorName);
    let i = settings.userSettings.plotSourcesHidden.has(sensorID);
    return !settings.userSettings.plotSourcesHidden.has(sensorID);
  }

  plotToggleOnAllSrc() {
    settings.userSettings.plotSourcesHidden.clear();
    settings.userSettings.showPlotSourcenodel(-1);
  }

  plotToggleOffAllSrc() {
    this.plotSources.forEach(item => {
      settings.userSettings.hidePlotSource(item);
    });
  }

  onPlotSourceToggle(sensorName) {
    let sensorID = this.plotSources.get(sensorName);
    let hidden = settings.userSettings.plotSourcesHidden.has(sensorID);
    hidden ? settings.userSettings.showPlotSource(sensorID) : settings.userSettings.hidePlotSource(sensorID);
  }

  onPlotsBrightnessSliderChanged(event: MatSliderChange) {
    settings.userSettings.setPlotOpacity(event.value / 100.0);
  }

  getPlotTypesSources() {
    return enums.PlotCorrTitles;
  }

  plotTypeSourceOn(index) {
    return settings.userSettings.plotTypeHidden[index];
  }

  onPlotTypeSourceToggle(index) {
    settings.userSettings.plotTypeHidden[index] = !settings.userSettings.plotTypeHidden[index];
    let hidden = settings.userSettings.plotTypeHidden[index];
    hidden ? settings.userSettings.showPlotType(index) : settings.userSettings.hidePlotType(index);
  }

  // private

  private getSettingsDlgPosition(settingsBtn: ElementRef): DialogPosition {
    let mainElem = document.firstElementChild;
    let rect = settingsBtn.nativeElement.getBoundingClientRect();
    return { top: `${rect.bottom}px`, right: `${mainElem.clientWidth - rect.left - 5}px` };
  }

  private openSettingsDlg(settingsDlg: ComponentType<any>, dialogId: string, settingsBtn: ElementRef<any>) {
    let dialogConfig = utils.createDialogConfig(false, false, dialogId, this.getSettingsDlgPosition(settingsBtn));
    dialogConfig.autoFocus = false;
    this.dialog.open(settingsDlg, dialogConfig);
  }

}
